import { render, staticRenderFns } from "./CoinsSubmitFooter.vue?vue&type=template&id=15ce0b2a&scoped=true&"
import script from "./CoinsSubmitFooter.vue?vue&type=script&lang=js&"
export * from "./CoinsSubmitFooter.vue?vue&type=script&lang=js&"
import style0 from "./CoinsSubmitFooter.vue?vue&type=style&index=0&id=15ce0b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce0b2a",
  null
  
)

export default component.exports